var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-command-home"},[_c('MapList'),(_vm.label_modal_visible)?_c('LabelModal'):_vm._e(),(_vm.tag_modal_visible)?_c('TagModal'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }